<template>
    <div class="bo-empty-wrapper">
        <img
            src="/assets/graphics/img_empty.svg"
            alt="image"
            class="empty-image"
        />
        <div class="title">Cart is empty</div>
        <div class="subtitle">You don't have any items in your cart</div>
        <button class="btn-rounded">
            <i class="icon-shoppingcart"></i>
            <span>Go Shopping Now</span>
        </button>
    </div>
</template>

<script>
export default {
    data: function () {
        return {};
    },

    mounted() {},

    methods: {},
};
</script>
